import _ from 'lodash'

function defaultConfig(binding) {
  let config = _.assign({
    container: 'body'
  }, binding.value || {})

  return config
}

function configure(config, el) {
  const placement = window.$(el).attr('data-placement')
  if (undefined !== placement) {
    config.placement = placement
  }

  const position = window.$(el).attr('data-position')
  if (undefined !== position) {
    config.position = position
  }

  const html = window.$(el).attr('data-html')
  if (undefined !== html) {
    config.html = 'true' === html
  }

  const trigger = window.$(el).attr('data-trigger')
  if (undefined !== trigger && _.includes(trigger, ['click', 'hover', 'focus', 'manual'])) {
    config.trigger = trigger
  }

  const show = window.$(el).attr('data-tooltip-show')
  if (undefined !== show) {
    config.show = 'true' === show
  }

  return config
}

export default {
  bind(el, binding) {
    if (!window.$) {
      return
    }

    let config = defaultConfig(binding)

    config = configure(config, el)

    window.$(el).tooltip(config)
  },
  unbind(el) {
    if (!window.$) {
      return
    }

    window.$(el).tooltip('destroy')
  }
}
